import { Box } from 'shared/components/Box/Box'
import { CloseButton } from 'shared/components/CloseButton/CloseButton'
import { Handler } from 'shared/helpers/typeHelper'
import { breakpoints } from 'shared/theme/breakpoints'
import { blueGray } from 'shared/theme/colors'
import { styled } from 'styled-components'

interface DrawerHeaderProps {
  onClose: Handler
  children?: React.ReactNode
}

export function DrawerHeader({ onClose, children }: DrawerHeaderProps) {
  return (
    <DrawerHeaderWrap className="drawer-header">
      <DrawerCloseButton onClose={onClose} />
      <Box smMt={3} />
      {children}
    </DrawerHeaderWrap>
  )
}

const DrawerHeaderWrap = styled.div<{
  $background?: string
}>`
  padding: 55px 40px 40px;
  grid-area: drawer-header;
  position: sticky;
  background: ${({ $background }) => $background ?? 'white'};
  top: 0;
  z-index: 5;

  @media ${breakpoints.sm} {
    padding: 20px;
  }
`

const DrawerCloseButton = styled(CloseButton)`
  position: absolute;
  top: 10px;
  left: 10px;

  svg {
    width: 25px;
    height: 25px;
    color: ${blueGray};
  }

  @media ${breakpoints.sm} {
    top: 5px;
    left: 5px;
  }
`
